import { useLogin } from "../../login/context/LoginContext";
import { Text, Button, Icon } from '@ui-component-library';
import { detectIosInAppBrowser } from "../helpers";

export default function LoginStart() {
    const LoginContext = useLogin();
    const { isIosInAppBrowser } = detectIosInAppBrowser();
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    let next_url = params.get('next');

    if (LoginContext.isLogged && next_url) {
        window.location = next_url;
    }

    return <>
        {LoginContext.isLogged ? <>
            <Text variant='text-xl/leading-none/medium'>Du är redan inloggad</Text>

            <Text variant='text-sm/leading-normal/normal' className='mt-2 text-muted-foreground'>Välj ett av nedan alternativ för att gå vidare:</Text>

            <Button variant='primary' onClick={() => window.location = '/min-skog/'} className='mt-2' fullWidth>Till min skog</Button>

            <Button variant='secondary' onClick={() => LoginContext.setShow(false)} className='mt-2' fullWidth>Avbryt</Button>

            <Button variant='primary' onClick={() => window.location = '/logout/'} className='mt-2' fullWidth>Logga ut</Button>
        </> : <>
            <Text variant='text-xl/leading-none/medium'>Logga in eller skapa ett konto kostnadsfritt</Text>

            <Text variant='text-sm/leading-normal/normal' className='mt-2 text-muted-foreground mb-8'>Verifiera med BankID, e-post eller telefonnummer för att fortsätta.</Text>

            {LoginContext.getFormFields(false)}

            {LoginContext.loading ? <div className='flex justify-center w-fill mt-2'>
                <div className="size-6 border-3 border-charcoal-500 border-t-transparent border-solid rounded-full animate-spin"></div>
            </div> :
                <>
                    {(LoginContext.exists?.mobile_phone_number == true || LoginContext.exists?.email == true) && LoginContext.storedIdentifiersAreValid() && <Button variant='primary' className='flex justify-between mt-3' onClick={() => LoginContext.sendLoginRegister()} fullWidth><div className='flex items-center gap-2'><Icon name='PasswordSimple' className='fill-white-500' /><span>Få engångskod</span></div> <Icon name='ArrowRightSimple' className='fill-white-500' /></Button>}

                    {LoginContext.exists && !LoginContext.exists?.mobile_phone_number && !LoginContext.exists?.email && LoginContext.storedIdentifiersAreValid() && <Button variant='primary' className='flex justify-between mt-3' onClick={() => LoginContext.setView('main')} fullWidth><div className='flex items-center gap-2'><Icon name='PasswordSimple' className='fill-white-500' /><span>Skapa konto</span></div> <Icon name='ArrowRightSimple' className='fill-white-500' /></Button>}
                </>}

            <div className="relative flex items-center my-4">
                <div className="flex-grow h-px bg-white-600"></div>
                <Text variant='text-xs/leading-normal/normal' className="flex-shrink mx-4 text-[#707376]">eller</Text>
                <div className="flex-grow h-px bg-white-600"></div>
            </div>

            {isIosInAppBrowser && (
                <Text variant='text-sm/leading-normal/normal' className='mt-2 text-muted-foreground mb-4'>
                    För att kunna logga in med BankID, klicka på de tre prickarna högst upp till höger och välj 'Öppna i extern webbläsare'.
                </Text>
            )}
            {!isIosInAppBrowser && <Button variant='primary' onClick={() => LoginContext.setView('bankid')} className='flex justify-between' fullWidth><div className='flex items-center gap-2'><Icon name='BankIdSimple' className='fill-white-500' /><span>Mobilt BankID</span></div> <Icon name='ArrowRightSimple' className='fill-white-500' /></Button>}
        </>}
    </>
}
